import React, { useState } from "react";
import { Box, Typography, Card, CardMedia, Chip, Button } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useTranslation } from "react-i18next";
import BgTitle from "components/title/BgTitle";
import nccBuildingImg from "../../images/GroupCompany/ncc-building-motoasakusa.jpeg";

export default () => {
  const { t } = useTranslation();
  const companyHistory = t("company_history.events", { returnObjects: true });
  const [displayCount, setDisplayCount] = useState(companyHistory.length / 2);

  const handleViewMore = () => {
    setDisplayCount(companyHistory.length);
  };

  return (
    <Box sx={{ pb: 4 }}>
      {/* Header Section */}
      <Box sx={{ px: 2, py: 4 }}>
        <BgTitle text={t("company_history.title")} isCenter={true} />
      </Box>

      {/* Building Image */}
      <Card
        elevation={0}
        sx={{
          mx: 2,
          mb: 4,
          borderRadius: 3,
          overflow: "hidden",
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <CardMedia
          component="img"
          height="200"
          image={nccBuildingImg}
          alt="NCC Cloud Office"
          sx={{
            objectFit: "cover",
            objectPosition: "center",
          }}
        />
      </Card>

      {/* History List */}
      <Box sx={{ px: 2 }}>
        {companyHistory.slice(0, displayCount).map((item, index) => (
          <Box
            key={index}
            sx={{
              position: "relative",
              pl: 3,
              mb: 2,
              "&::before": {
                content: '""',
                position: "absolute",
                left: 0,
                top: 0,
                bottom: 0,
                width: 2,
                bgcolor: "primary.main",
                opacity: 0.2,
              },
              "&::after": {
                content: '""',
                position: "absolute",
                left: -4,
                top: 16,
                width: 10,
                height: 10,
                borderRadius: "50%",
                bgcolor: "primary.main",
              },
            }}
          >
            <Box
              sx={{
                mt: 1,
                p: 1,
                bgcolor: "#f5f5f5",
                borderRadius: 2,
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                border: "1px solid",
                borderColor: "divider",
              }}
            >
              <Chip
                label={item.year}
                size="small"
                sx={{
                  mb: 1,
                  fontWeight: 700,
                  bgcolor: "primary.lighter",
                  color: "primary.main",
                  fontSize: "0.7rem",
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  color: "text.primary",
                  lineHeight: 1.6,
                  fontSize: "0.7rem",
                }}
              >
                {item.event}
              </Typography>
            </Box>
          </Box>
        ))}

        {/* View More Button */}
        {displayCount < companyHistory.length && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 4,
            }}
          >
            <Button
              variant="text"
              onClick={handleViewMore}
              endIcon={<KeyboardArrowDownIcon sx={{ color: "#666" }} />}
              sx={{
                textTransform: "none",
                color: "#333",
                fontSize: "0.95rem",
                fontWeight: 500,
                px: 4,
                py: 1.5,
                borderRadius: 3,
                backgroundColor: "#f5f5f5",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#eee",
                  boxShadow: "none",
                },
                "&:active": {
                  backgroundColor: "#e0e0e0",
                },
              }}
            >
              {t("company_history.show_more_btn")}
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};
